<h2 class="font-bold" mat-dialog-title>Map to an existing policy </h2>

<p class="text-lg font-medium text-gray-800 mb-2">
    Please select a policy to map to
    <mat-hint class="block text-sm text-gray-500 mt-1">
        Selection is unavailable for already mapped policies
    </mat-hint>
  </p>

<div *ngIf="allPolicies.length === 0">
    <p class="text-lg  text-gray-800 mb-2">
        No policies available for selection
    </p>
</div>

<mat-dialog-content>
    <mat-radio-group [(ngModel)]="selectedPolicyId">
        <mat-radio-button  *ngFor="let policy of allPolicies" [value]="policy.id" class="!block mt-3">
            <span class="text-blue-500">
                {{ policy.id }}
            </span>
            <span>
                {{policy.displayName}}
            </span>
        </mat-radio-button>
    </mat-radio-group>
</mat-dialog-content>



<mat-dialog-actions>
    <button mat-raised-button color="primary" [class.loading-btn]="false" [disabled]="!selectedPolicyId" (click)="onConfirm()"
    cdkFocusInitial>Confirm</button>
    <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
